import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// @mui material components
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import ImageUpload from "components/CustomUpload/ImageUpload";

import {
	REMOVE_CITY_IMAGE,
	SET_CITY_FILES_IMAGES,
	REMOVE_CITYMAP_IMAGE,
	SET_CITYMAP_FILES_IMAGES,
	SET_CITY_NAME,
	SET_CITY_NAME_ERROR,
	SET_CITY_REGISTER_KEY,
	DELETE_CITY_CHANNEL,
	REORDER_CITY_CHANNELS,
	ADD_CITY_CHANNEL,
	SET_CITY_CUSTOM_URI,
	SET_CITY_CUSTOM_URI_ERROR,
	SET_CITY_LOGO_FILES_IMAGES,
	REMOVE_CITY_LOGO_IMAGE,
	SET_CITY_COLLECT_WEATHER
} from "actions/types";
import { fetchSearchCityChannels } from "actions/channel";

import SortableTags from "components/DigiHapi/SortableTags";

class Step1 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, name, customUri } = this.props;

		let success = true;
		if (!name || name.trim().length === 0) {
			dispatch({
				type: SET_CITY_NAME_ERROR
			});
			success = false;
		}
		if (!customUri || customUri.trim().length === 0) {
			dispatch({
				type: SET_CITY_CUSTOM_URI_ERROR
			});
			success = false;
		}
		return success;
	}

	onImageLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_CITY_FILES_IMAGES,
			payload: [{ name, base64: imagePreviewUrl, out: "photoUri" }]
		});
	};

	onImageRemoved = () => {
		this.props.dispatch({
			type: REMOVE_CITY_IMAGE
		});
	};

	onLogoLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_CITY_LOGO_FILES_IMAGES,
			payload: [{ name, base64: imagePreviewUrl, out: "logoUri" }]
		});
	};

	onLogoRemoved = () => {
		this.props.dispatch({
			type: REMOVE_CITY_LOGO_IMAGE
		});
	};

	onCityMapLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_CITYMAP_FILES_IMAGES,
			payload: [
				{
					name,
					base64: imagePreviewUrl,
					ignoreQualityTransform: true,
					out: "mapUri"
				},
				{ name: name + "-small", base64: imagePreviewUrl, out: "mapSmallUri" }
			]
		});
	};

	onCityMapRemoved = () => {
		this.props.dispatch({
			type: REMOVE_CITYMAP_IMAGE
		});
	};

	handleDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_CITY_CHANNEL,
				index
			});
		}
	};

	handleReorder = (from, to) => {
		this.props.dispatch({
			type: REORDER_CITY_CHANNELS,
			from,
			to
		});
	};

	handleAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_CITY_CHANNEL,
			value: channel
		});
	};

	onInput = query => {
		if (query?.length > 2) {
			this.props.fetchSearchCityChannels(query, this.props.ignoreWeather);
		}
	};

	handleToggleCollectWeather = () => {
		this.props.dispatch({
			type: SET_CITY_COLLECT_WEATHER,
			value: !this.props.collectWeather
		});
	};

	render() {
		const {
			dispatch,
			name,
			nameErrorMsg,
			customUri,
			customUriErrorMsg,
			photoUri,
			logoUri,
			mapSmallUri,
			registerkey,
			channels,
			channelsSuggestions,
			collectWeather
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12} sm={4}>
					<MDTypography component="div" variant="h6" mb={1}>
						Couverture
					</MDTypography>
					<ImageUpload
						onImageLoaded={this.onImageLoaded}
						onImageRemoved={this.onImageRemoved}
						photoUri={photoUri}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<MDTypography component="div" variant="h6" mb={1}>
						Logo
					</MDTypography>
					<ImageUpload
						onImageLoaded={this.onLogoLoaded}
						onImageRemoved={this.onLogoRemoved}
						photoUri={logoUri}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<MDTypography component="div" variant="h6" mb={1}>
						Plan intéractif
					</MDTypography>
					<ImageUpload
						onImageLoaded={this.onCityMapLoaded}
						onImageRemoved={this.onCityMapRemoved}
						photoUri={mapSmallUri}
					/>
				</Grid>
				<Grid item xs={12}>
					<FormControlLabel
						control={
							<Checkbox
								checked={!!collectWeather}
								onChange={this.handleToggleCollectWeather}
							/>
						}
						label="Collecte de la méteo"
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Nom *"
						id="name"
						fullWidth
						error={!!nameErrorMsg}
						helperText={nameErrorMsg}
						value={name || ""}
						onChange={e =>
							dispatch({
								type: SET_CITY_NAME,
								value: e.target.value
							})
						}
						autoComplete="new-password"
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="URI *"
						id="uri"
						fullWidth
						error={!!customUriErrorMsg}
						helperText={customUriErrorMsg}
						value={customUri || ""}
						onChange={e =>
							dispatch({
								type: SET_CITY_CUSTOM_URI,
								value: e.target.value
							})
						}
						autoComplete="new-password"
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Clé de la ville pour rejoindre la communauté"
						id="registerkey"
						fullWidth
						value={registerkey || ""}
						onChange={e =>
							dispatch({
								type: SET_CITY_REGISTER_KEY,
								value: e.target.value
							})
						}
						autoComplete="new-password"
					/>
				</Grid>
				<Grid item xs={12}>
					<FormHelperText>
						{
							"Canaux de diffusion depuis lesquelles recevoir les publications et bons plans"
						}
					</FormHelperText>
					<SortableTags
						placeholderText="Canaux de diffusion ..."
						tags={channels}
						suggestions={channelsSuggestions}
						minQueryLength={3}
						maxSuggestionsLength={10}
						onDelete={this.handleDelete}
						onAddition={this.handleAddition}
						onReorder={this.handleReorder}
						suggestionsFilter={() => true}
						onInput={this.onInput}
						removeButtonText="Cliquez pour retirer"
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		name,
		nameErrorMsg,
		logoUri,
		mapSmallUri,
		registerkey,
		channels,
		channelsSuggestions,
		customUri,
		customUriErrorMsg,
		photoUri,
		ignoreWeather,
		collectWeather
	} = state.cityReducer;
	return {
		name,
		nameErrorMsg,
		logoUri,
		mapSmallUri,
		registerkey,
		channels: Object.values(channels),
		channelsSuggestions: Object.values(channelsSuggestions),
		customUri,
		customUriErrorMsg,
		photoUri,
		ignoreWeather,
		collectWeather
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchSearchCityChannels
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step1);
